import { userEndPoints } from "../config";
import CommonService from "./CommonService";
class userService {
  async getWalletDetails() {
    return CommonService.get(userEndPoints.getWallet);
  }

  async addBankDetails(data) {
    return CommonService.put(userEndPoints.addBank, data);
  }

  async payoutRequest(amount) {
    return CommonService.put(userEndPoints.requestPayout, { amount });
  }

  async getOrderDetails(limit, page) {
    return CommonService.get(
      userEndPoints.getOrders + `?page=${page}&limit=${limit}`
    );
  }

  async getAllPyaoutTransaction(limit, page) {
    return CommonService.get(
      userEndPoints.payoutTransactions + `?page=${page}&limit=${limit}`
    );
  }

  async getCouponValidity(coupon, totalAmount, orderType) {
    return CommonService.get(
      userEndPoints.couponValidity + `${coupon}/${totalAmount}/${orderType}`
    );
  }

  async getAllVideos() {
    return CommonService.get(userEndPoints.allReels);
  }

  async getCouponBanner() {
    return CommonService.get(userEndPoints.getBanners);
  }

  async getSubHeaderTagline() {
    return CommonService.get(userEndPoints.getSubHeader);
  }

  async getAvailableCoupons() {
    return CommonService.get(userEndPoints.getAllCoupons);
  }
}
const userServiceInstance = new userService();

export default userServiceInstance;
